import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import { PageLinks } from "../../common/page-links";

import PlayVideo from "../Play/PlayVideo";
import ReviewsImg from "../../images/reviews-img.jpg"
import Img01 from "../../images/feefo-img.svg"
import "./Reviews.scss";

const Reviews = () => {

  let [isPlay, setPlay] = React.useState(false);

  return (
    <React.Fragment>
      {/* <section className="reviews-section">
        <Container>
          <Row>
            <Col md="12" lg="6" className="details-wrap order-md-2 order-xl-1">
              <Link to="/">
                <i className="icon-star"></i>
              </Link>
              <p>“During my rent back in 2018, my property manager was Gita Patel who has been an excellent and proactive agent regarding any matter about the property, and off my experience in renting properties, without a doubt she is an outstanding agent. Thanks to John Shepherds who set an excellent example,
                and would definitely recommend them.”</p>
              <div className="sm-info">
                <h6>Alex Parris</h6>
                <span className="time">2 days ago</span>
              </div>
              <div className="reviews-details">
                <img src={Img01} alt="img" />
                <span className="all-rating">4.6/5 <span>from</span></span>
                <Link to={`/${PageLinks.reviews}/`} className="total-count d-none d-md-inline-block">53 Customer Reviews</Link>
                <Link to={`/${PageLinks.reviews}/`} className="total-count d-inline-block d-md-none">53 Reviews</Link>
              </div>
            </Col>
            <Col md="12" lg="6" className="order-md-1 order-xl-2">
              <div className="reviews-img img-zoom">
                <img src={ReviewsImg} alt="ReviewsImg" />
                <div className="reviews-content">
                  <h3>Adam Jenkins</h3>
                  <span className="sm-info">First time buyer with us</span>
                </div>

                <button className="video-wrap" onClick={e => { setPlay(true) }}>
                  <i className="icon-video"></i>
                </button>
              </div>

            </Col>
          </Row>
        </Container>
      </section> */}
      <PlayVideo
        isOpen={isPlay}
        isCloseFunction={setPlay}
        videoId="V8ksSGxo6no"
        isAutoPlay={1}
      />
    </React.Fragment>
  );
};
export default Reviews;